import { useState, useEffect } from 'react'
import { DatePicker, IconButton, Input } from '@fullscreendigital/carrefour-dex-fe'
import { Paper, Grid, Stack, Box, useMediaQuery, InputAdornment } from '@mui/material'
import { useNotification } from 'hooks'
import { Icon } from 'components/core-ui/Icon'
import cn from 'classnames'
import { makeCorePutRequest } from 'utils/api'
import { ProductBarcodeScannerProps } from '../ProductBarcodeScanner/ProductBarcodeScannerDefinitions'
import s from '../ProductBarcodeScanner/ProductBarcodeScanner.modules.scss'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { formatPayloadDate, isScannerDevice } from 'utils/helpers'
import { formatErrorMessage } from 'utils/formatting'
import dayjs from 'dayjs'
import { CloseMenu } from 'icons'

const ReceiptBarcodeScanner = (props: ProductBarcodeScannerProps) => {
  const { action } = props

  const [code, setCode] = useState('')
  const [receiptNumber, setReceiptNumber] = useState('')
  const [receiptDate, setReceiptDate] = useState(dayjs())
  const [isVisible, setIsVisible] = useState(false)
  const isXs = useMediaQuery('(max-width:624px)')
  const { showNotification } = useNotification()
  const navigate = useNavigate()

  const { id } = useParams()

  const [searchParams] = useSearchParams()

  const sendReceipt = () => {
    if (code && receiptDate) {
      ;(async () => {
        if (action.type === 'PUT') {
          try {
            await makeCorePutRequest(`${action.url}/${id}`, {
              fiscalTicketBarcode: code,
              fiscalTicketNumber: receiptNumber,
              fiscalTicketDate: formatPayloadDate(receiptDate)
            })

            if (action.href) {
              navigate(
                `/supplyOmni/${action.href}?${action.variable}=${id}&clientId=${searchParams.get(
                  'clientId'
                )}`
              )
            }
          } catch (error) {
            showNotification({
              message: `A aparut o eroare la trimiterea bonului. ${formatErrorMessage(error)}`,
              type: 'error'
            })
          }
        }
      })()
    }
  }

  useEffect(() => {
    document.getElementById('receipt-scan-input').focus()
  }, [])

  const clearReceipt = () => {
    setCode('')
    document.getElementById('receipt-scan-input').focus()
  }

  return (
    <div>
      <Grid container spacing={4}>
        <Grid xs={12} sm={12} md={6} lg={6} item>
          <div className={s.scannerControlItem} style={{ marginBottom: '16px' }}>
            <Input
              value={code}
              type="text"
              variant="outlined"
              label="Introdu codul de bare al bonului"
              fullWidth
              onChange={event => setCode(event.currentTarget.value)}
              id="receipt-scan-input"
              required
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    className={s.clearIconAdornment}
                    onClick={clearReceipt}
                  >
                    <CloseMenu fill={'rgba(0, 0, 0, 0.87)'} />
                  </InputAdornment>
                )
              }}
            />
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid xs={12} sm={12} md={6} lg={6} item>
          <div className={s.scannerControlItem} style={{ marginBottom: '16px' }}>
            <Input
              value={receiptNumber}
              type="text"
              variant="outlined"
              label="Introdu numarul bonului (EJTRZ)"
              fullWidth
              onChange={event => setReceiptNumber(event.currentTarget.value)}
              required
            />
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid xs={12} sm={12} md={6} lg={6} item>
          <div className={s.pickerContainer} style={{ paddingLeft: 0, marginBottom: '16px' }}>
            <DatePicker
              label="Alege data bonului"
              value={receiptDate}
              variant="outlined"
              style={{
                padding: 0,
                width: '100%',
                '& .MuiTextField-root': { padding: 0, width: '100%' }
              }}
              closeButtonLabel="Inchide"
              confirmButtonLabel="Confirma"
              required
              onChange={newValue => setReceiptDate(newValue)}
            />
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid xs={12} sm={12} md={12} lg={12} item>
          <Stack
            sx={{ mt: 1, mb: 3 }}
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 1, md: 1 }}
          >
            <Box sx={isXs ? { width: '100%' } : { width: '50%' }}>
              <IconButton
                sx={isXs ? { width: '100%' } : { width: '50%' }}
                onClick={sendReceipt}
                label="Continua"
                variant="contained"
                endIcon={<Icon iconName="ArrowRightSharp" tiny={true} fill="white" />}
              />
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </div>
  )
}

export default ReceiptBarcodeScanner
